import { render } from "./ClaimCorporateAccountPage.vue?vue&type=template&id=4429e92c&scoped=true"
import script from "./ClaimCorporateAccountPage.vue?vue&type=script&lang=js"
export * from "./ClaimCorporateAccountPage.vue?vue&type=script&lang=js"

import "./ClaimCorporateAccountPage.vue?vue&type=style&index=0&id=4429e92c&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4429e92c"]])

export default __exports__